export function fadeOut(k, duration = 1, onComplete) {
    const fadeOverlay = k.add([
        k.rect(k.width(), k.height()),
        k.color(0, 0, 0),
        k.opacity(0),
        k.fixed(),
        k.z(1000),
    ]);

    k.tween(
        0,
        1,
        duration,
        (val) => fadeOverlay.opacity = val,
        k.easings.easeInQuad
    );

    k.wait(duration, () => {
        if (onComplete) onComplete();
    });
}